export const ScreenSize = {
 BreakpoinTablet: 768,
 BreakpointLaptop: 1025,
 BreakpointLargeScreen: 1600
};


